var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t(
        "label_essweb_leaveBalance_form_dialog_newLeaveTransactionTitle"
      ),
      dialog: _vm.show,
      width: "800",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_leaveBalance_form_dialog_leaveTypeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.leaveType,
                            "item-text": "leave_type_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_leaveBalance_form_dialog_leaveTypeLabel"
                            ),
                            filled: "",
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.TransactionsData.leave_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.TransactionsData,
                                "leave_type_uuid",
                                $$v
                              )
                            },
                            expression: "TransactionsData.leave_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_leaveBalance_form_dialog_transactionTypeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.Transactiontype,
                            disabled: !_vm.TransactionsData.leave_type_uuid,
                            "item-text": "leave_transaction_type_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_leaveBalance_form_dialog_transactionTypeLabel"
                            ),
                            filled: "",
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.TransactionsData.transaction_type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.TransactionsData,
                                "transaction_type",
                                $$v
                              )
                            },
                            expression: "TransactionsData.transaction_type",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.logic_method == "D"
                      ? [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c("DateTimePicker", {
                                attrs: {
                                  type: "datetime",
                                  defaultTime:
                                    _vm.TransactionsData.start_utc_datetime,
                                  max: _vm.TransactionsData.end_utc_datetime,
                                  rules: _vm.$GetRules(
                                    ["_Require_Rules"],
                                    [null]
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_leaveBalance_form_dialog_leaveStartTimeLabel"
                                  ),
                                },
                                on: {
                                  change: function (time) {
                                    return (_vm.TransactionsData.start_utc_datetime =
                                      time)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c("DateTimePicker", {
                                attrs: {
                                  type: "datetime",
                                  defaultTime:
                                    _vm.TransactionsData.end_utc_datetime,
                                  min: _vm.TransactionsData.start_utc_datetime,
                                  label: _vm.$t(
                                    "label_essweb_leaveBalance_form_dialog_leaveEndTimeLabel"
                                  ),
                                },
                                on: {
                                  change: function (time) {
                                    return (_vm.TransactionsData.end_utc_datetime =
                                      time)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "month",
                            defaultTime: _vm.TransactionsData.leave_period,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_leaveBalance_form_dialog_leavePeriodLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.TransactionsData.leave_period = time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_leaveBalance_form_dialog_totalDayHourLabel"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  xs: "12",
                                  sm: "6",
                                  md: "4",
                                  lg: "4",
                                  cols: "12",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    "single-line": "",
                                    maxlength: "11",
                                    type: "number",
                                    rules: _vm.$GetRules(
                                      ["_Number_negative", "_Length_Rules"],
                                      [null, 11]
                                    ),
                                    filled: "",
                                    placeholder: "days",
                                  },
                                  model: {
                                    value: _vm.TransactionsData.days,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.TransactionsData,
                                        "days",
                                        $$v
                                      )
                                    },
                                    expression: "TransactionsData.days",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-sheet",
                              {
                                staticClass: "text-subtitle-1 text-center",
                                staticStyle: {
                                  "line-height": "65px !important",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("label_essweb_system_dayLabel"))
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  xs: "12",
                                  sm: "6",
                                  md: "4",
                                  lg: "4",
                                  cols: "12",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    type: "number",
                                    "single-line": "",
                                    maxlength: "11",
                                    rules: _vm.$GetRules(
                                      ["_Number_negative", "_Length_Rules"],
                                      [null, 11]
                                    ),
                                    filled: "",
                                    placeholder: "hours",
                                  },
                                  model: {
                                    value: _vm.TransactionsData.hours,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.TransactionsData,
                                        "hours",
                                        $$v
                                      )
                                    },
                                    expression: "TransactionsData.hours",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-sheet",
                              {
                                staticClass: "text-subtitle-1 text-center",
                                staticStyle: {
                                  "line-height": "65px !important",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("label_essweb_system_hourLabel")
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          {
                            staticClass:
                              "white--text rounded-lg pa-3 subtitle-1",
                            attrs: { color: "primary" },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_leaveBalance_form_dialog_totalMinutesLabel"
                                  )
                                ) +
                                  ": " +
                                  _vm._s(
                                    _vm.$get_thousand_num(_vm.totalMinute)
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.$t("label_essweb_system_minutesLabel")
                                  )
                              ),
                            ]),
                            _c("span"),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            defaultTime:
                              _vm.TransactionsData.effective_utc_time,
                            filled: "",
                            max: _vm.TransactionsData.expired_utc_time,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_leaveBalance_form_dialog_effectiveStartDateLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.TransactionsData.effective_utc_time =
                                time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            filled: "",
                            min: _vm.TransactionsData.effective_utc_time,
                            defaultTime: _vm.TransactionsData.expired_utc_time,
                            label: _vm.$t(
                              "label_essweb_leaveBalance_form_dialog_expiredDateLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.TransactionsData.expired_utc_time =
                                time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_leaveBalance_form_dialog_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            dense: "",
                            counter: "500",
                            "single-line": "",
                            filled: "",
                          },
                          model: {
                            value: _vm.TransactionsData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.TransactionsData, "remarks", $$v)
                            },
                            expression: "TransactionsData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: { new: _vm.toNew, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }